import React from 'react';

import { makeSpotifyPostRequest } from '../../config/SpotifyRequests'


import Loader from '../loader/Loader'
import Error from '../../widgets/error/Error'
import Information from '../../widgets/information/Information'

class CreateListModal extends React.Component {
    state = {
        formData: {
            name: '',
            description: ''
        },
        fetching: false
    }

    changeHandler = (e, field) => {
        const fd = this.state.formData;
        fd[field] = e.target.value
        this.setState({
            formData: {
                ...fd
            }
        })
    }
    submit = async (e) => {
        e.preventDefault()
        this.setState({fetching: true})

        try{
            const data = {
                ...this.state.formData
            }

            const response = await makeSpotifyPostRequest(`https://api.spotify.com/v1/users/${this.props.user.id}/playlists`, data, this.props.accessToken)
            this.props.setModal(<Information message={`Playlist created : you can start adding tracks.`} />)
        }catch(e){
            this.props.setModal(<Error message={`An unkown error has occured : could not create playlist, please try again later!`} />)
        }
    }
    render(){
        return (
            <>
                { !this.state.fetching && 
                 <div className="create-list-modal">
                    <form onSubmit={this.submit}>
                        <div className='form__control'>
                            <input type="text" value={this.state.formData.name} onChange={(e)=>this.changeHandler(e, 'name')} placeholder='Playlist name'/>
                        </div>
                        <div className='form__control'>
                            <textarea  resize='off' value={this.state.formData.description} onChange={(e)=>this.changeHandler(e, 'description')} placeholder='Description'>
                                </textarea>
                        </div>
                        <button type="submit" className='form__submit'>ADD PLAYLIST</button>
                    </form>
                </div>
                }
                { this.state.fetching && <Loader /> }
            </>
        )
    }
}
export default CreateListModal;
